/* eslint-disable no-case-declarations */
import {
  SET_NOTIFICATION, NOTIFICATION_REQUEST_FAILED, SENDING_NOTIFICATION_REQUEST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  nData: '',
  isNSending: false,
  nError: false,
  isNSuccess: false,
};

/**
* dispatched the user data to the store
* @param  { Object } state  default state
* @param  { Object } action dispacthed action from middleware
*/
export default function getNotifications(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_NOTIFICATION:
      const data = {};
      data.nData = action.nData.data;
      data.isNSending = action.isNSending;
      data.isNSuccess = action.isNSuccess;
      data.nError = action.nError;
      return { ...state, ...data };

    case SENDING_NOTIFICATION_REQUEST:
      const sendingRequest = {};
      sendingRequest.nData = action.nData;
      sendingRequest.isNSending = action.isNSending;
      sendingRequest.isNSuccess = action.isNSuccess;
      sendingRequest.nError = action.nError;
      return { ...state, ...sendingRequest };

    case NOTIFICATION_REQUEST_FAILED:
      const errors = {};
      errors.nData = action.nData;
      errors.isNSending = action.isNSending;
      errors.isNSuccess = action.isNSuccess;
      errors.nError = action.nError;
      errors.nMsg = action.nMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
